import Vue from 'vue'
import Router from 'vue-router'
import TextPrep from './views/TextPrep.vue'
import NikudEdit from './views/NikudEdit.vue'
import ApiChildHandler from './views/ApiChildHandler.vue'
import {AppConfig} from './appConfig';
import Projects from 'shared/dropbox/Projects'
import {firebaseStore} from 'shared/account'
import store from './store'

Vue.use(Router)

let routesArray = [
  {
    path: '/',
    name: 'text-prep',
    component: TextPrep
  },
  {
    path: '/edit',
    name: 'nikud-edit',
    component: NikudEdit
  }
]

if (AppConfig.OFFER_DROPBOX) routesArray.push(
  {
    path: '/projects*',
    name: 'Projects',
    component: Projects,
    props: () => ({ editScreen: store.state.allWorkingNikud
                             && store.state.allWorkingNikud.wordsArray
                             && store.state.allWorkingNikud.wordsArray.length > 0
                             && store.state.originalDocument
                             && store.state.originalDocument.text
                             && store.state.originalDocument.id === store.state.allWorkingNikud.id ? 
      {to: '/edit', name:  Vue.prototype.$settings.hebrew ? 'עריכת תוצאות' : 'Results Edit screen'} 
      : null })
  },
  {
    path: '/dropbox-auth',
    name: 'dropbox-auth',
    beforeEnter (to, from,  next) {
      const params = new Map(
        to.hash.substring(1)  // remove the hash character
          .split('&')   // key-value pairs are split by &
          .map(str => str.split('=', 2))  // key and value are split by =
      )
      firebaseStore('dropbox_token', params.get('access_token'))
      next('/projects')
    }
  }
)

routesArray.push(
  {
    path: AppConfig.SERVER_ROOT + '/*',
    name: 'api-child-handler',
    component: ApiChildHandler
  },
  {
    path: '/*',
    redirect: '/',
  }
)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routesArray
})
